import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DeeplinkService } from "../../services/deeplink.service";
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-deeplink-launch',
  standalone: true,
  templateUrl: `./deeplink-launch.html`,
  imports: [ProgressSpinnerModule],
  providers: [DeeplinkService]
})
export class DeeplinkLaunchComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private deeplinkingService = inject(DeeplinkService);

  async ngOnInit() {
    const toolId = this.route.snapshot.paramMap.get('toolId')!;
    const courseCode = this.route.snapshot.paramMap.get('courseCode')!;

    const data = await this.deeplinkingService.getDeeplinkingContent({ toolId, courseCode });

    // Create form and submit - navigates away from Angular
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = data.action;
    // No target = submits in current window
    
    delete data.action;
    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = typeof value === 'string' ? value : JSON.stringify(value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }
}